import axios from "axios";
import { toast } from "util";

axios.defaults.withCredentials = true;
const service = axios.create({
  baseURL: "/v1/H5Gateway?",
  timeout: 10000 // 请求超时时间
});

service.interceptors.request.use(
  config => {
    config.url += `&user_id=${process.env.VUE_APP_USER_ID}&login_token=${process.env.VUE_APP_TOKEN}`;
    return config;
  },
  error => {
    toast(error.message);
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    let result;
    const data = response.data || {};
    if (response.status !== 200) {
      // TODO: 不同状态码返回不同提示toast(), +抛错
      result = Promise.reject(new Error("fail"));
    } else {
      result = data.response_json ? JSON.parse(data.response_json) : "";
    }
    return result;
  },
  error => {
    toast(error.message);
    return Promise.reject(error);
  }
);

export default service;
